module.exports = __webpack_public_path__ + "static/593-154b13eefb05be2ca87287899b3b842d.png";